import { GET_API, POST_API } from "../../Functionalities/APIs";

const bodyOf = (result) => (result && result.data ? result.data : null);

const form = (fields) => {
  const data = new FormData();
  Object.keys(fields).forEach((key) => {
    if (fields[key] !== undefined && fields[key] !== null && fields[key] !== "") data.append(key, fields[key]);
  });
  return data;
};

export const fetchOverview = async () => bodyOf(await GET_API("", "", "/ota/admin/overview/"));

export const activateUpdate = async (updateId) => bodyOf(await POST_API(form({}), "", `/ota/admin/updates/${updateId}/activate/`));

export const offerUpdate = async (updateId, runtimeVersion, channel) =>
  bodyOf(await POST_API(form({ runtime_version: runtimeVersion, channel }), "", `/ota/admin/updates/${updateId}/offer/`));

export const rollbackToBuiltIn = async (app, channel, runtimeVersion) =>
  bodyOf(await POST_API(form({ app, channel, runtime_version: runtimeVersion }), "", "/ota/admin/rollback/"));

export const setPaused = async (app, channel, paused) =>
  bodyOf(await POST_API(form({ app, channel, paused: paused ? "true" : "false" }), "", "/ota/admin/pause/"));

const parts = (version) => String(version || "").split(".").map((p) => parseInt(p, 10) || 0);

export const versionsSorted = (runtimes) =>
  [...(runtimes || [])].sort((a, b) => {
    const left = parts(a.runtime_version);
    const right = parts(b.runtime_version);
    for (let i = 0; i < Math.max(left.length, right.length); i += 1) {
      const diff = (right[i] || 0) - (left[i] || 0);
      if (diff) return diff;
    }
    return 0;
  });

const when = (iso) => {
  const date = new Date(iso);
  return Number.isNaN(date.getTime()) ? "unknown time" : date.toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" });
};

export const shortId = (id) => String(id || "").slice(0, 8);

export const servedLine = (runtime) => {
  if (runtime.rolled_back_at) return `Rolled back to the built-in bundle at ${when(runtime.rolled_back_at)}`;
  const current = runtime.current;
  if (!current) return "Nothing published";
  const platforms = (current.platforms || []).join(", ");
  const message = current.message ? `${current.message} · ` : "";
  return `${message}published ${when(current.created_at)} · ${shortId(current.update_id)}${platforms ? ` · ${platforms}` : ""}`;
};

export const devicePills = (devices) => {
  const d = devices || {};
  return [
    { key: "total", label: "Phones", value: d.total || 0 },
    { key: "seen", label: "Seen in 7 days", value: d.seen_last_7_days || 0 },
    { key: "current", label: "On current", value: d.on_current || 0 },
    { key: "other", label: "On older", value: d.on_other || 0 },
    { key: "embedded", label: "On built-in", value: d.on_embedded || 0 },
    { key: "android", label: "Android", value: d.android || 0 },
    { key: "ios", label: "iOS", value: d.ios || 0 },
  ];
};

export const APP_CHOICES = [
  { value: "rider", label: "Delivery app" },
  { value: "restaurant", label: "Restaurant app" },
  { value: "customer", label: "Customer app" },
];

export const UPDATE_CHANNEL = "production";

export const publishProblem = ({ app, runtimeVersion, file }) => {
  if (!app) return "Choose the app";
  if (!/^\d+\.\d+\.\d+$/.test(String(runtimeVersion || "").trim())) return "Enter the app version, like 3.1.2";
  if (!file) return "Choose the zip the export script made";
  if (!/\.zip$/i.test(file.name || "")) return "Choose a .zip file";
  return null;
};

export const publishUpdate = async ({ app, runtimeVersion, note, file }) =>
  bodyOf(
    await POST_API(
      form({ app, runtime_version: String(runtimeVersion).trim(), channel: UPDATE_CHANNEL, message: note, bundle: file }),
      "",
      "/ota/admin/publish/"
    )
  );
